import * as React from "react";
import {
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { CollapseList, EditModal } from "./CollapseList";
import { db } from "../../firebase";
import { deleteDoc, doc } from "firebase/firestore";

export default function CategoryItem({ value }) {
  const [open, setOpen] = React.useState(false);
  // open and close the collapse
  const handleClick = () => {
    setOpen(!open);
  };

  const deleteTopCat = (id) => {
    // console.log("Deleted ", id);
    // return;

    // create document ref
    const itemRef = doc(db, "heading", id);

    deleteDoc(itemRef).then(() => {
      console.log("Deleted");
    });
  };

  const editTopCat = (id) => {
    console.log("Edited ", id);
    return;
  };

  return (
    <div>
      <div>
        <ListItemButton onClick={handleClick}>
          {open ? <ExpandLess /> : <ExpandMore />}
          <ListItemText primary={value.name} sx={{ pl: 2 }} value={value.id} />
          {/* <IconButton sx={{ mr: 2 }} onClick={() => editTopCat(value.id)}>
            <EditIcon />
          </IconButton> */}

          <EditModal value={value} i={0} />

          <IconButton onClick={() => deleteTopCat(value.id)}>
            <DeleteIcon />
          </IconButton>
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {/* load sub categories */}
            <CollapseList id={value.id} />
          </List>
        </Collapse>
      </div>
    </div>
  );
}
